import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const title: SxStyle = {
  lineHeight: 2,
};
